import React from "react";
import { connect } from "react-redux";

import {
  getStudentParentConsentIDList,
  getSchoolByID,
  getStudentSchoolID
} from "state/school_money/selectors";

import List from "components/List";
import ScrollableContainer from "components/ScrollableContainer";
import PlaceholderCard from "components/school_money/PlaceholderCard";
import ParentalConsentItem from "components/school_money/parental_consent/ParentalConsentItem";

class StudentParentalConsentList extends React.Component {
  
  renderPlaceholder() {
    return <PlaceholderCard objectName="parental consent" school={this.props.school} />
  }
  
  render() {
    return (
      <ScrollableContainer className="parental-consent-list">
        <List placeholder={this.renderPlaceholder()}>
          {
            this.props.parentalConsentIDList.map(itemID => (
              <ParentalConsentItem key={itemID} itemID={itemID} />
            ))
          }
        </List>
      </ScrollableContainer>
    );
  }
  
}

export default connect(
  (state, { studentID }) => ({
    parentalConsentIDList: getStudentParentConsentIDList(state, studentID),
    school: getSchoolByID(state, getStudentSchoolID(state, studentID))
  })
)(StudentParentalConsentList);



// WEBPACK FOOTER //
// ./src/components/school_money/parental_consent/StudentParentalConsentList.js